import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ReactHtmlParser from 'react-html-parser';

const BylineWrapper = styled.div`
  max-width: 650px;
  width: 100%;
  margin: 1.5rem 0 ;
  position: relative;
  padding-top: 1.5rem;
  &:before {
    content: '';
    display: block;
    width: 120px;
    background-color: var(--custom-red);
    height: 1px;
    position: absolute;
    right: 0;
    top: 0;
  }
  p {
    font-size: 0.875rem;
    line-height: 1.125rem;
    color: white
    text-align: center;
    margin-bottom: 0.25rem;
    a {
      color: white;
    }
  }
  @media (max-width: 1100px) {
    width: 100%;
    max-width: 700px;
    &:before {
      right: auto;
      left: 0;
    }
  }
`;

const Bylines = ({ data, pubDate }) => {
  const bylineWriter = `By <a class="bentonsanscond-n6" href='https://www.bostonglobe.com${data[0].url}' target="_blank" rel="noreferrer">${data[0].name}</a>, Globe Staff`;

  const bylinePhotographer = `Photos by <a class='bentonsanscond-n6' href='https://www.bostonglobe.com${data[1].url}' target="_blank" rel="noreferrer">${data[1].name}</a>, Globe Staff`;

  // constructing the publish date graph based on if there is a pubDate object
  // and whether that object has publishDate and updateDate
  let publishGraph;
  if (pubDate && pubDate.pubDate) {
    publishGraph = `Published ${pubDate.pubDate}`;
  }
  if (pubDate && pubDate.updateDate) {
    publishGraph += `. Updated ${pubDate.updateDate}.`;
  }

  const pubGraph = publishGraph !== undefined
    ? <p className="bentonsanscond-n4">{publishGraph}</p>
    : null;

  return (
    <BylineWrapper className="byline__wrapper">
      <p className="bentonsanscond-n4">{ReactHtmlParser(bylineWriter)}</p>
      <p className="bentonsanscond-n4">{ReactHtmlParser(bylinePhotographer)}</p>
      {pubGraph}
    </BylineWrapper>
  );
};

Bylines.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      url: PropTypes.string,
    }),
  ).isRequired,
  pubDate: PropTypes.shape({
    pubDate: PropTypes.string,
    updateDate: PropTypes.string,
  }),
};

Bylines.defaultProps = {
  pubDate: null,
};

export default Bylines;
